import React, { useRef, useState, useContext, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import "./Banner.css";
import axios from "axios";
import Black_btn from "../../common-components/common-button/black-btn/Black_btn";
import { getHomeBanners } from "../../../utils/apis/homepage";
import { IDS } from "../../../utils/common";
import { Context } from "../../../utils/context";

function Banner() {
  const [banner, setBanner] = useState([]);

  const getBanner = async () => {
    const res = await getHomeBanners();
    if (res?.success) setBanner(res.data);
  };

  useEffect(() => {
    getBanner();
  }, []);

  return (
    <section className="home-banner">
      <div className="container-fluid p-0">
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          pagination={{
            clickable: true,
          }}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          // breakpoints={{
          //   0: {
          //     slidesPerView: 1,
          //     spaceBetween: 0,
          //   },
          //   575: {
          //     slidesPerView: 1,
          //     spaceBetween: 0,
          //   },
          //   991: {
          //     slidesPerView: 1,
          //     spaceBetween: 0,
          //   },
          // }}

          modules={[Pagination, Autoplay]}
          className="mySwiper"
        >
          {banner?.map((item, index) => (
            <SwiperSlide>
              <div className="banner-div">
                <img
                  className="banner-img"
                  src={IDS?.IMG_URL + item?.image}
                  alt="home-banner"
                />
              </div>
            </SwiperSlide>
          ))}
          {/* <SwiperSlide>
            <div className="banner-div" >
              <img className="banner-img" src={process.env.PUBLIC_URL + '/assets/images/home/banner/home-banner2.png'} alt="home-banner" />
            </div>
          </SwiperSlide> */}
          {/* <SwiperSlide>
            <div className="banner-div" >
              <img className="banner-img" src={process.env.PUBLIC_URL + '/assets/images/home/banner/home-banner3.png'} alt="home-banner" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="banner-div" >
              <img className="banner-img" src={process.env.PUBLIC_URL + '/assets/images/home/banner/home-banner1.png'} alt="home-banner" />
            </div>
          </SwiperSlide> */}
        </Swiper>

        {/* <div className="container">
          <Black_btn btn_name={'Contact Us'} btn_link={'/contact-us'} />
        </div> */}
      </div>
    </section>
  );
}

export default Banner;
